






import { Component, Vue } from 'vue-property-decorator'
import CodeBrunchCalculator from '@/components/CodeBrunchCalculator.vue'

@Component({
  components: {
    CodeBrunchCalculator
  }
})
export default class Home extends Vue {
}
